import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

import LogoImpact120 from "./LogoImpact120.png";
import LucieSVG from "./Lucie.svg";
import NRLabelSVG from "./NRLevel1.svg";

export const NumeriqueResponsableLabel = () => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col">
      <div className="flex gap-3">
        <a
          href="https://www.impactfrance.eco/nos-actus/impact-40-120-2025-decouvrez-les-laureats-2025"
          aria-label="Impact 40/120 award"
          className="relative w-18 h-[86px]"
        >
          <Image
            src={LogoImpact120}
            alt="Label 120"
            className="object-contain"
            sizes="(max-width: 768px) 96px, 112px"
          />
        </a>

        <a href="https://label-nr.fr/" aria-label="label numeric responsable">
          <NRLabelSVG />
        </a>

        <a href="https://agence-lucie.com/" aria-label="label lucie">
          <LucieSVG />
        </a>
      </div>
    </div>
  );
};
